import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { SlidersHorizontal as SlidersHorizontalIcon } from 'lucide-react';
import { PageHeader } from '@/components/page-header';
import { ServerCreateForm } from '@/components/server-create-form';

export const Route = createFileRoute('/_app/admin/servers/new')({ component: NewServer });

function NewServer() {
  const navigate = useNavigate();
  return (
    <>
      <PageHeader
        title="New server"
        icon={SlidersHorizontalIcon}
        description="The server is created on the node and its install script runs straight away."
      />
      <ServerCreateForm
        mode="create"
        onCreated={(server) =>
          navigate({ to: '/admin/servers/$serverId', params: { serverId: String(server.id) } })
        }
      />
    </>
  );
}
